export default `<rich-text-view class-name="'feedback-text__body'" x-data-hook="'view-feedback-text-body'" content="$ctrl.text"> </rich-text-view> `;